import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "textarea", "fileInput" ]

  connect() {
    console.log("FastaUpload controller connected")
    this.fileInputTarget.accept = ".txt,.fasta,.fa,.fas,.fna,.ffn,.faa,.frn"
  }

  async handleFileSelect(event) {
    console.log("File selected:", event.target.files[0])

    const file = event.target.files[0]
    if (!file) return

    try {
      const content = await file.text()
      console.log("File content loaded, length:", content.length)
      this.textareaTarget.value = content

      // Dispatch input event to trigger any form validations
      const inputEvent = new Event('input', { bubbles: true })
      this.textareaTarget.dispatchEvent(inputEvent)
    } catch (error) {
      console.error("Error reading file:", error)
      alert("Error reading file. Please try again.")
    } finally {
      // Clear the file input so the same file can be selected again
      this.fileInputTarget.value = ''
    }
  }
}
